import React, { useCallback, useState } from "react";
import { View } from "react-native";
import {
    useForm,
    useAuth,
    useAuthSession,
    Spacer,
    Surface,
    StyleFunction,
    useThemedStyle,
    Logo,
} from "@venuepos/react-common";
import { LoginForm } from "./login-form";
import { SelectUserRole } from "./select-user-role";
import { ValidationSchema } from "lib";

export type LoginFormData = {
    username: string;
    password: string;
};

const loginSchema: ValidationSchema<LoginFormData> = {
    username: { required: true },
    password: { required: true },
};

const defaultLoginData = {
    username: "",
    password: "",
};

export function LoginScreen() {
    const [{ authToken }] = useAuthSession(["authToken"]);
    const styles = useThemedStyle(styleFunc);
    const auth = useAuth();
    const form = useForm<LoginFormData>(loginSchema, defaultLoginData);
    const [authenticated, setAuthenticated] = useState<boolean | undefined>();
    const [{ values }, { reset, handleSubmit }] = form;

    const handleSignIn = useCallback(async () => {
        const success = await auth.signIn(values!.username, values!.password);
        reset();
        setAuthenticated(success);
    }, [auth, values, reset]);

    return (
        <View style={styles.container}>
            <Logo />
            <Spacer space={2} />
            <Surface style={styles.box}>
                {!authToken ? (
                    <LoginForm
                        form={form}
                        authenticated={authenticated}
                        handleSubmit={handleSubmit(handleSignIn)}
                    />
                ) : (
                    <SelectUserRole
                        signOut={auth.signOut}
                        selectUserRole={auth.selectUserRole}
                    />
                )}
            </Surface>
        </View>
    );
}

const styleFunc: StyleFunction = theme => ({
    container: {
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.colors.grey50,
    },
    box: {
        elevation: 4,
        backgroundColor: theme.colors.white,
        minWidth: "25%",
        padding: theme.spacingScale * 4,
    },
});
